export default __webpack_public_path__ + "static/media/slidepic.a5435e65.jpg";